import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import kitchenImage from "../why-choose-img-4.jpg"; 
// Use your image file, or different ones as needed

const DesignsHyderabad = () => (
  <div className="container my-5">
     
    <h2 class="text-anime-style-2 text-center my-5" data-cursor="-opaque">Explore Designs</h2>
    <p className="wow fadeInUp" data-wow-delay="0.2s" >
      At MeHome, we believe every home deserves a touch of elegance and personality. Discover our beautifully curated interior design ideas from cozy 1BHK setups to luxurious 3BHK spaces. Whether you dream of a modern kitchen, a serene bedroom, or a stylish living room, we bring creativity, comfort, and functionality together to transform your vision into reality.
    </p>
     
    <div className="row">
      <div className="col-md-4 mb-4">
        <div className="card shadow-sm">
          <img src="/imgs/one-bhk-interior-designs.jpg" className="card-img-top" alt="Modular Kitchens" style={{height:"250px", objectFit:"cover"}}/>
          <div className="card-body">
            <h5 className="card-title fw-semibold">1 BHK Interior Designs</h5>
            <a href="/one-bhk-interior-designs" className="text-danger fw-semibold">Explore &rarr;</a>
          </div>
        </div>
      </div>
      <div className="col-md-4 mb-4">
        <div className="card shadow-sm">
          <img src="/imgs/two-bhk-interior-designs.jpg" className="card-img-top" alt="Bedrooms" style={{height:"250px", objectFit:"cover"}}/>
          <div className="card-body">
            <h5 className="card-title fw-semibold">2 BHK Interior Designs</h5>
            <a href="/two-bhkinterior-designs" className="text-danger fw-semibold">Explore &rarr;</a>
          </div>
        </div>
      </div>
      <div className="col-md-4 mb-4">
        <div className="card shadow-sm">
          <img src="/imgs/three-bhk-interior-designs.jpg" className="card-img-top" alt="Living Rooms" style={{height:"250px", objectFit:"cover"}}/>
          <div className="card-body">
            <h5 className="card-title fw-semibold">3 BHK Interior Designs</h5>
            <a href="/three-bhk-interior-designs" className="text-danger fw-semibold">Explore &rarr;</a>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default DesignsHyderabad;